module.exports = __webpack_public_path__ + "nhelp_icon.svg";